import { ObjectLiteral } from '@prophecy/interfaces/generic';
import queryString from 'query-string';

const CSRF_WINDOW_KEY = '__prophecy-csrf-token';
export const CSRF_TOKEN_KEY = 'csrf-token';

const windowStore = window as ObjectLiteral;

export const csrf = {
  key: CSRF_TOKEN_KEY,
  get() {
    return windowStore[CSRF_WINDOW_KEY] as string;
  },
  set(value: string) {
    windowStore[CSRF_WINDOW_KEY] = value;
  },
  delete() {
    windowStore[CSRF_WINDOW_KEY] = null;
  }
};

export function addCSRFQuery(url: string) {
  return queryString.stringifyUrl({ url, query: { [CSRF_TOKEN_KEY]: csrf.get() } });
}
